module.exports = "images/basisschool-wijzer.jpg";